import { render } from "./RunUserAIFormulaModalContent.vue?vue&type=template&id=6ec04e5c&lang=true"
import script from "./RunUserAIFormulaModalContent.vue?vue&type=script&lang=js"
export * from "./RunUserAIFormulaModalContent.vue?vue&type=script&lang=js"

import "./RunUserAIFormulaModalContent.vue?vue&type=style&index=0&id=6ec04e5c&lang=css"
script.render = render

export default script